import { render, staticRenderFns } from "./CTA01.vue?vue&type=template&id=6170a1e0"
import script from "./CTA01.vue?vue&type=script&lang=js"
export * from "./CTA01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports